var $ = jQuery = require('jquery');
var Pikaday = require('./pikaday');
require('jquery.scrollto');
require('angular');
require('respimage');
require('./helpers');
require('./magnificpopup.min')
require('./hashcode')
var modernizr = require('./modernizr')
// require('../../../node_modules/atp-ng/dist/ng-atp');

require('./atp');
require('./slider_plugin');
require('./blc-app-init')
require('./greencicle');
require('./browser_info');
require('./calendar-directive');
require('./google-places-directive');
require('./xlat-service');
require('./currency-service');
require('./quote_service');
require('./redcontrol-directive');
require('./search-form-directive');
require('./quote_directive');
require('./filter_popup_ctrl');
require('./footer-ctrl');
require('./cars_list_ctrl');
require('./search_ctrl');
require('./hotoffer_ctrl');
require('./recent-search-ctrl');
// require('./sendEmail_ctrl');
require('./contact-controller');
require('./menu-directive');
require('./script');


var quote_hash = 0;// hate globals, but $scope updates suxx
Storage.prototype.setObject = function(key, value) { this.setItem(key, JSON.stringify(value)) };
Storage.prototype.getObject = function(key) { 
  var value = this.getItem(key);  
  try {
    return JSON.parse(value); 
  } catch (ex) { return null; }
}

Array.prototype.find_by_prop = function(prop_name, prop_value) {
  for (ind in this) {
    if (!this.hasOwnProperty(ind)) continue;
    if (this[ind][prop_name]==prop_value) return this[ind];
  };
  return null;
}
window.jsonlddata = []



/*****************
 ** WEBPACK FOOTER
 ** ./gulp/assets/javascripts/main.js
 ** module id = 0
 ** module chunks = 0
 **/